import React from 'react';
import styled from 'styled-components';
import { useImagesContext } from '../../../contexts/ImagesContext';

export const EggNumber = ({ number, fontHeight, top, filePrefix }) => {
  const { images } = useImagesContext();
  const imageTagList = [];
  let dividedResult = number;
  let key = 1;
  while (dividedResult > 0) {
    const oneDigitNumber = dividedResult % 10;
    imageTagList.push(
      <img
        style={{ height: fontHeight, position: 'relative' }}
        key={key}
        src={images[`${filePrefix}${oneDigitNumber}.png`]}
        alt=""
      />
    );
    dividedResult = Math.floor(dividedResult / 10);
    key += 1;
  }
  return (
    <NumberBlock $top={top} $height={fontHeight}>
      {imageTagList.reverse()}
    </NumberBlock>
  );
};

const NumberBlock = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  top: ${(props) => props.$top};
  height: ${(props) => props.$height};
  width: 100%;
`;